import { render, staticRenderFns } from "./purchase-order-change.vue?vue&type=template&id=637024b0&scoped=true&"
import script from "./purchase-order-change.vue?vue&type=script&lang=js&"
export * from "./purchase-order-change.vue?vue&type=script&lang=js&"
import style0 from "./purchase-order-change.vue?vue&type=style&index=0&id=637024b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637024b0",
  null
  
)

export default component.exports